(function () {
  /**
   * @ngdoc module
   * @name akitabox.mobile.directives.inputProgress
   */
  angular
    .module("akitabox.mobile.directives.inputProgress", [])
    .directive("abmInputProgress", AbmInputProgressDirective);

  /** @ngInject */
  /**
   * @ngdoc directive
   * @module akitabox.mobile.directives.inputProgress
   * @name AbmInputProgressDirective
   *
   * @description
   * `abm-input-progress` adds a linear progress indicator to the bottom of an input
   *
   * @usage
   * <hljs lang="html">
   *
   * <input type="text" ng-model="vm.asset.room" abm-input-progress="vm.fetchingRooms" />
   *
   * </hljs>
   */
  function AbmInputProgressDirective($compile, $log) {
    return {
      restrict: "EA",
      link: postLink,
      scope: {
        loading: "&abmInputProgress",
        progressClas: "@?abmProgressClass",
      },
    };

    function postLink($scope, $element) {
      // Default progress bar class to `md-accent`
      if (angular.isEmpty($scope.progressClass))
        $scope.progressClass = "md-accent";

      // Create progress element
      var $progress = angular.element(
        "<md-progress-linear " +
          'ng-show="loading()" ' +
          'class="abm-input-progress ' +
          $scope.progressClass +
          '"' +
          'md-mode="indeterminate">' +
          "</md-progress-linear>"
      );

      var $input = getInputElement();

      // Verify an input element exists
      if ($input.length === 0)
        return $log.error("abm-input-progress:", "No input element found");

      // Add the progress bar to the DOM
      attachProgressBar();

      // Watch for loading changes and enable/disable element
      $scope.$watch("loading()", function (loading) {
        if (loading) disableInput();
        else enableInput();
      });

      /**
       * Attach the progress bar to the elements parent
       */
      function attachProgressBar() {
        $progress.css("top", $input[0].offsetHeight + "px");
        $progress = $compile($progress)($scope);
        angular.element($input.parent()).append($progress);
      }

      /**
       * Find the input element
       *
       * @return {Object} Angular input element
       */
      function getInputElement() {
        if ($element[0].tagName !== "INPUT") return $element.find("input");
        return $element;
      }

      /**
       * Disable the input element
       */
      function disableInput() {
        $input.attr("disabled", "disabled");
      }

      /**
       * Enable the input element
       */
      function enableInput() {
        $input.removeAttr("disabled");
      }
    }
  }
})();
